// Global data > Settings history.
import { Link } from "react-router-dom";

import { PageHeader } from "../components/PageHeader";
import { SettingsHistory } from "../components/SettingsHistory";
import { useDocumentTitle } from "../utils/useDocumentTitle";

export const GlobalDataHistoryRoute = () => {
  useDocumentTitle("Global data settings history");
  return (
    <section>
      <PageHeader title="Global data settings history" />
      <SettingsHistory
        scope="global"
        intro={
          <>
            Every change to how global data is set up, newest first.{" "}
            <Link to="/global-data">Back to global data</Link>
          </>
        }
      />
    </section>
  );
};
